import { useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import ConfirmAction from 'components/popups/ConfirmAction';
import useSeasonEventSave from 'hooks/useSeasonEventSave';
import { canCloseSeasonEvent } from 'utility/seasonSeating';

export default function SeasonEventClose({ event, disabled, onClosed }) {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const { save, loading } = useSeasonEventSave();

    if (!event?.parent_event_id || Number(event.seats_flag) !== 1) return null;

    if (event.seats_closed_at) {
        return (
            <Alert severity="info" sx={{ mb: 3 }}>
                This season event is closed, and seats booked for this event are now available to season ticket buyers.
            </Alert>
        );
    }

    if (!canCloseSeasonEvent(event)) return null;

    return (
        <Box mb={3}>
            <Alert
                severity="warning"
                sx={{ '& .MuiAlert-action': { alignItems: 'center', paddingTop: 0 } }}
                action={
                    <Button
                        color="inherit"
                        size="small"
                        sx={{ whiteSpace: 'nowrap' }}
                        disabled={disabled || loading}
                        onClick={() => setConfirmOpen(true)}
                    >
                        Close Event
                    </Button>
                }
            >
                This event is concluded. Close it so seats booked for this event will be available for season ticket buyers.
            </Alert>
            <ConfirmAction
                open={confirmOpen}
                title="Close Season Event"
                confirmText="Close Event"
                onCancel={() => setConfirmOpen(false)}
                onConfirm={() => {
                    setConfirmOpen(false);
                    save({
                        endpoint: `/apiv2/events/${event.event_id}/season-close`,
                        method: 'POST',
                        body: { confirm: true },
                        fallback: 'There was a problem closing this season event.',
                        onSuccess: onClosed,
                    });
                }}
                description={
                    <Typography>
                        Closing this event is permanent. You cannot reopen it or change details of this event. Existing tickets and reports
                        are kept as is.
                    </Typography>
                }
            />
        </Box>
    );
}
